import http from './http';

// me.DROPBOX_TREE = '/dropbox/tree?path=';
// me.DOWNLOAD_PATH = '/dropbox/download/';
// me.UPLOAD_PATH = '/dropbox/upload';
// me.REMOVE_PATH = '/dropbox/remove?path=';
const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
export function list({url, auth, token, delay, path='', page='', start='', limit=''}){
  url += `/dropbox/tree?path=${path}&_dc=${new Date().getTime()}&page=${page}&start=${start}&limit=${limit}`;
  return http(url,auth,token, delay).then((data)=>{
    _.each(data,(entry)=>{
      if(entry.isDropBox){
        entry.icon = 'dropbox';
      }else if(entry.isFile){
        entry.icon = 'file';
      }else{
        entry.icon = entry.type.toLowerCase();
      }

      entry.extension = entry.isFile && entry.name.indexOf('.')!==-1?entry.name.split('.').pop():''
      entry.lastModified = entry.LastModified;
      entry.fullPath = entry.path+'/'+entry.name;
      delete entry.LastModified;
      entry.sizeBytes = entry.size;

      if (entry.sizeBytes == 0) {entry.size = '';}
      else{
        var i = parseInt(Math.floor(Math.log(entry.sizeBytes) / Math.log(1024)));
        entry.size = Math.round(entry.sizeBytes / Math.pow(1024, i), 2) + ' ' + sizes[i];        
      }
      });
    return data;
  });  
}

export function download({url, auth, token, path, name}){  
  const a = document.createElement('a');
  a.setAttribute('href', getFileUrl({url, auth, token, path, name}));
  a.setAttribute('download', name);
  a.style.display='none';
  document.body.appendChild(a);  
  a.click();
  a.remove();
}

export function getFileUrl({url, auth, token, path, name}){
  url += http.auth(`/dropbox/download/${path}/${name}`,auth, token);  
  return url;  
}

export function upload({url, auth, token, path='', delay, file, onProgress, }){
  if(file){
    const payload = new FormData();
    payload.append('path', path);
    payload.append('fileToUpload', file);    
    return http(`${url}/dropbox/upload?path=${path}`,auth,token, delay,'json', 'POST', payload,onProgress).then((data)=>{    
      return data&&data[0]&&!data[0].error&&data[0].fileInfo;
    });
  }else{
    return new Promise((resolve,reject)=>{
      const input = document.createElement('input');
      input.setAttribute('type', 'file');
      
      input.addEventListener('change',()=>{
        const payload = new FormData();
        payload.append('path', path);
        payload.append('fileToUpload', input.files[0]);    
        http(`${url}/dropbox/upload?path=${path}`,auth,token, delay,'json', 'POST', payload,onProgress).then((data)=>{    
          console.log('upload complete', data);
          resolve(data&&data[0]&&!data[0].error&&data[0].fileInfo);
        });  
      })
      input.addEventListener('blur',()=>{
        setTimeout(()=>{        
            input.remove();        
        },0);
      })
      document.body.appendChild(input);  
      input.focus();
      input.click();    
    });    
  }
}

export function remove({url, auth, token, path, name, delay}){
  url += `/dropbox/remove?path=${path}/${name}`;
  return http(url,auth,token, delay, 'text');  
}

export function mput({url, auth, token, path='', delay, file, onProgress, codec, partId, close }){
  const payload = new FormData();
  // payload.append('path', path);
  // payload.append('fileName', file.name);
  // payload.append('codec', codec);
  // payload.append('partId', partId);
  // payload.append('close', close);

  if(file){
    payload.append('body', file);

    return http(`${url}/dropbox/mput?path=${ encodeURIComponent(path)}&fileName=${ encodeURIComponent(file.name)}&codec=${ encodeURIComponent(codec)}&partId=${encodeURIComponent(partId)}&close=${ encodeURIComponent(close)}`,auth,token, delay,'json', 'POST', payload,onProgress).then((data)=>{    
      return data&&data[0]&&!data[0].error&&data[0].fileInfo;
    });
  }else{
    return new Promise((resolve,reject)=>{
      const input = document.createElement('input');
      input.setAttribute('type', 'file');
      
      input.addEventListener('change',()=>{
        
        payload.append('body', input.files[0]);    
        http(`${url}/dropbox/mput?path=${path}`,auth,token, delay,'json', 'POST', payload,onProgress).then((data)=>{    
          console.log('mput complete', data);
          resolve(data&&data[0]&&!data[0].error&&data[0].fileInfo);
        });  
      })
      input.addEventListener('blur',()=>{
        setTimeout(()=>{        
            input.remove();        
        },0);
      })
      document.body.appendChild(input);  
      input.focus();
      input.click();    
    });    
  }
}